import { render } from "./StockExitsListPage.vue?vue&type=template&id=c0e3d3a2&ts=true"
import script from "./StockExitsListPage.vue?vue&type=script&lang=ts"
export * from "./StockExitsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__